import { registerPlugin } from '@capacitor/core';

import { KountPlugin as KountPluginType } from './kount-plugin.types';

export const KountPlugin = registerPlugin<KountPluginType>('Kount', {
  web: () => import('./kount-plugin.web').then((m) => new m.KountPluginWeb()),
});
